/* Measures the pinned top stack (announcement bar + header) into CSS custom
   properties so sticky offsets and anchor scroll padding always clear it.
   Dawn only measures the header (--header-height); the announcement bar is
   pinned too on this build, so downstream offsets use --ntd-top-stack. */
(function () {
  var doc = document.documentElement;

  function measure() {
    var announcement = document.querySelector('.announcement-bar-section');
    var header = document.querySelector('.section-header');
    var announcementH = announcement ? announcement.offsetHeight : 0;
    var headerH = header ? header.offsetHeight : 0;
    doc.style.setProperty('--ntd-announcement-height', announcementH + 'px');
    doc.style.setProperty('--ntd-top-stack', announcementH + headerH + 'px');
  }

  function init() {
    measure();
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(measure);
      var announcement = document.querySelector('.announcement-bar-section');
      var header = document.querySelector('.section-header');
      if (announcement) ro.observe(announcement);
      if (header) ro.observe(header);
    } else {
      window.addEventListener('resize', measure);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Comparison card "Add to Cart" proxies the one authoritative product form. */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ntd-comparison-atc]');
    if (!btn) return;
    var mainSubmit = document.querySelector('product-info .product-form__submit');
    if (mainSubmit && !mainSubmit.hasAttribute('disabled')) mainSubmit.click();
  });
})();

/* Micro-review clamp: reveal the Read more toggle only when the quote
   actually overflows; toggle expands/collapses in place. */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-ntd-micro-review]').forEach(function (card) {
      var quote = card.querySelector('.ntd-micro-review__quote');
      var btn = card.querySelector('[data-ntd-review-toggle]');
      if (!quote || !btn) return;
      if (quote.scrollHeight > quote.clientHeight + 2) btn.hidden = false;
      btn.addEventListener('click', function () {
        var expanded = card.classList.toggle('ntd-micro-review--expanded');
        card.classList.toggle('ntd-micro-review--clamped', !expanded);
        btn.setAttribute('aria-expanded', String(expanded));
        btn.textContent = expanded ? 'Show less' : 'Read more';
      });
    });
  });
})();

/* LSC-172 reviews track (ntd-reviews section): arrow buttons scroll one
   card, the status reads "1-2 of 10", controls hide when every card fits.
   Read more shows only on clamped cards; expanding one card stretches its
   neighbours too, so the boxes stay the same size. */
(function () {
  function init(root) {
    var track = root.querySelector('.ntd-reviews__track');
    var controls = root.querySelector('[data-ntd-review-controls]');
    if (!track || !controls) return;
    var cards = track.querySelectorAll('.ntd-review-card');
    var prev = root.querySelector('[data-ntd-review-prev]');
    var next = root.querySelector('[data-ntd-review-next]');
    var status = root.querySelector('[data-ntd-review-status]');
    cards.forEach(function (card) {
      var body = card.querySelector('.ntd-review-card__body');
      var more = card.querySelector('[data-ntd-review-more]');
      if (!body || !more) return;
      if (body.scrollHeight > body.clientHeight + 2) more.hidden = false;
      more.addEventListener('click', function () {
        var expanded = card.classList.toggle('is-expanded');
        more.setAttribute('aria-expanded', String(expanded));
        more.textContent = expanded ? 'Show less' : 'Read more';
      });
    });
    function step() {
      var first = cards[0];
      if (!first) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return first.getBoundingClientRect().width + gap;
    }
    function update() {
      var total = cards.length;
      var fits = track.scrollWidth <= track.clientWidth + 2;
      controls.hidden = fits || total < 2;
      if (controls.hidden) return;
      var w = step();
      var firstIdx = Math.round(track.scrollLeft / w);
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var perView = Math.max(1, Math.floor((track.clientWidth + gap + 2) / w));
      var lastIdx = Math.min(total, firstIdx + perView);
      status.textContent = (perView > 1 ? (firstIdx + 1) + '-' + lastIdx : String(firstIdx + 1)) + ' of ' + total;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    var t;
    track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(update, 60); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-ntd-review-carousel]').forEach(init);
  });
})();

/* Gallery thumbnail cap: show exactly four VISIBLE thumbnails (artifact
   layout). Dawn hides non-matching variant thumbs itself, so we count
   only what Dawn left visible; re-applied after every variant change
   (Dawn re-renders the media section). No-JS fallback: full strip. */
(function () {
  function capThumbs() {
    document.querySelectorAll('.thumbnail-slider .thumbnail-list').forEach(function (list) {
      var shown = 0;
      list.querySelectorAll('.thumbnail-list__item').forEach(function (item) {
        item.style.removeProperty('display');
        if (getComputedStyle(item).display === 'none') return;
        shown += 1;
        if (shown > 4) item.style.display = 'none';
      });
    });
  }
  document.addEventListener('DOMContentLoaded', capThumbs);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      requestAnimationFrame(function () { setTimeout(capThumbs, 100); });
    });
  }
})();

/* "Write a review" (ntd-reviews section): triggers the Judge.me v3 review
   widget's own write button — its form opens as a body-level modal, so the
   inline widget itself stays parked off-screen and never duplicates our
   custom review cards. If the widget hasn't set up yet, briefly reveal the
   host (v3 sets up lazily on visibility) and keep polling. */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ntd-write-review]');
    if (!btn) return;
    var host = document.querySelector('[data-ntd-jdgm-host]');
    if (!host) return;
    var findWrite = function () {
      var els = host.querySelectorAll(
        '.jm-action-buttons__button, .jm-button--primary, .jdgm-write-rev-link'
      );
      for (var i = 0; i < els.length; i++) {
        if (/write a review/i.test(els[i].textContent)) return els[i];
      }
      return null;
    };
    var attempt = 0;
    var tryOpen = function () {
      var link = findWrite();
      if (link) {
        link.click();
        host.classList.remove('is-open');
        return;
      }
      attempt++;
      if (attempt === 6) host.classList.add('is-open');
      if (attempt < 30) {
        setTimeout(tryOpen, 400);
      } else if (!document.querySelector('.ntd-reviews__form-fallback')) {
        // Judge.me never initialized (script blocked?). Honest fallback
        // with the store's real support address, shown next to the button.
        host.classList.remove('is-open');
        var note = document.createElement('p');
        note.className = 'ntd-reviews__empty ntd-reviews__form-fallback';
        note.textContent =
          'The review form did not load. Please refresh the page, or email your review to support@lthr.us.';
        btn.insertAdjacentElement('afterend', note);
      }
    };
    tryOpen();
  });

  /* LSC-165 (2026-10-12): review request emails link here with
     ?write_review=1 (or #write-review). Only 2 reviews after ~150 Woodward
     orders: shoppers landed on the section and still had to find the
     button. Open the form for them once the page has settled. */
  var wantsForm = /[?&]write_review=1/.test(window.location.search) || window.location.hash === '#write-review';
  if (!wantsForm) return;
  var openForm = function () {
    var section = document.getElementById('reviews');
    var btn = document.querySelector('[data-ntd-write-review]');
    if (!section || !btn) return;
    section.scrollIntoView({ block: 'start' });
    btn.click();
  };
  if (document.readyState === 'complete') setTimeout(openForm, 800);
  else window.addEventListener('load', function () { setTimeout(openForm, 800); });
})();

/* Mobile gallery snap fallback (Skylar iPhone report 2026-08-14): even with
   scroll-behavior:auto, WebKit can leave the media slider parked between
   slides. After scrolling stops (and no finger is down), glide to the
   nearest slide. No-op on engines where CSS snap already settled. */
(function () {
  var list = document.querySelector('.product__media-list.slider--mobile');
  if (!list) return;
  var mq = window.matchMedia('(max-width: 749px)');
  var timer = null;
  var touching = false;
  function settle() {
    if (touching || !mq.matches) return;
    var slides = list.querySelectorAll('.product__media-item');
    if (slides.length < 2) return;
    var pitch = slides[1].offsetLeft - slides[0].offsetLeft;
    if (pitch <= 0) return;
    var max = list.scrollWidth - list.clientWidth;
    var target = Math.min(Math.round(list.scrollLeft / pitch) * pitch, max);
    if (Math.abs(list.scrollLeft - target) > 2) {
      list.scrollTo({ left: target, behavior: 'smooth' });
    }
  }
  list.addEventListener(
    'scroll',
    function () {
      clearTimeout(timer);
      timer = setTimeout(settle, 120);
    },
    { passive: true }
  );
  list.addEventListener(
    'touchstart',
    function () {
      touching = true;
      clearTimeout(timer);
    },
    { passive: true }
  );
  list.addEventListener(
    'touchend',
    function () {
      touching = false;
      clearTimeout(timer);
      timer = setTimeout(settle, 140);
    },
    { passive: true }
  );
})();

/* Pin the mobile media-card size in pixels (see ntd-theme.css note). */
(function () {
  var list = document.querySelector('.product__media-list');
  if (!list) return;
  function size() {
    var item = list.querySelector('.product__media-item');
    if (!item) return;
    var w = Math.round(item.getBoundingClientRect().width);
    if (w > 0) list.style.setProperty('--ntd-media-size', w + 'px');
  }
  size();
  window.addEventListener('load', size);
  window.addEventListener('resize', size);
  window.addEventListener('orientationchange', size);
})();

/* Scroll reveals: one-shot rise-in for [data-ntd-reveal] elements. */
(function () {
  var els = document.querySelectorAll('[data-ntd-reveal]');
  if (!els.length) return;
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('ntd-revealed'); });
    return;
  }
  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ntd-revealed');
          io.unobserve(entry.target);
        }
      });
    },
    /* Eager reveal (Skylar 2026-08-20): elements start revealing 35% of a
       viewport BELOW the fold, so the section after the hero is already
       painted at load and content finishes rising before it scrolls into
       view - no blank band while scrolling. Was threshold .15 / -8%. */
    { threshold: 0.05, rootMargin: '0px 0px 35% 0px' }
  );
  els.forEach(function (el) { io.observe(el); });
})();

/* Color-aware gallery (Skylar 2026-08-26): media tagged "color::<Name>;" in
   its alt follows the Color picker; other variants' studio thumbs stay
   hidden. Every media stays in the DOM (media-gallery.js crashes on a
   missing thumbnail), so this only toggles [hidden] — the same rules the
   server renders for the first paint. Runs after product-info.js finishes
   its section sync (variantChange fires last). */
(function () {
  if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;
  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    var variant = event && event.data && event.data.variant;
    if (!variant) return;
    document.querySelectorAll('media-gallery[data-ntd-color-index]').forEach(function (gallery) {
      var idx = parseInt(gallery.dataset.ntdColorIndex, 10);
      var color = idx >= 0 && variant.options ? variant.options[idx] : null;
      var hwIdx = parseInt(gallery.dataset.ntdHwIndex || '-1', 10);
      var hw = hwIdx >= 0 && variant.options ? variant.options[hwIdx] : null;
      var hwOk = function (li) { return !li.dataset.ntdHw || hw === null || li.dataset.ntdHw === hw; };
      var featuredId = String((variant.featured_media && variant.featured_media.id) || '');
      gallery.querySelectorAll('.product__media-item[data-ntd-color], .product__media-item[data-ntd-hw]').forEach(function (li) {
        var colorOk = !li.dataset.ntdColor || color === null || li.dataset.ntdColor === color;
        li.hidden = !(colorOk && hwOk(li));
      });
      gallery.querySelectorAll('.thumbnail-list__item').forEach(function (li) {
        var tag = li.dataset.ntdColor || '';
        var attached = li.classList.contains('thumbnail-list_item--variant');
        var isFeatured = featuredId !== '' && (li.dataset.target || '').slice(-featuredId.length - 1) === '-' + featuredId;
        var show;
        if (attached) {
          show = isFeatured || (tag !== '' && color !== null && tag === color);
        } else {
          show = tag === '' || color === null || tag === color;
        }
        li.hidden = !(show && hwOk(li));
      });
      /* Staging 2026-10-19: Dawn's slider caches its visible slides, so after a
         color switch (Black 5 photos -> Brown 11) swiping past slide 5 threw
         "Cannot read properties of undefined (reading 'dataset')" in
         media-gallery.js and the 1/5 counter went stale. Recount now. */
      gallery.querySelectorAll('slider-component').forEach(function (slider) {
        if (typeof slider.resetPages === 'function' && slider.slider) slider.resetPages();
      });
    });
  });
})();

/* Clickable dropdown parents. Dawn renders a nav item that has children as a
   <details>/<summary> toggle only, so the parent's own URL is unreachable on
   desktop. For mouse users at desktop width the submenu opens on hover and a
   click on the parent follows its link (data-ntd-url, stamped by
   header-dropdown-menu.liquid). Keyboard and touch keep the stock toggle. */
(function () {
  var mq = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  var mouse = false;
  document.addEventListener('pointerdown', function (e) { mouse = e.pointerType === 'mouse'; }, true);
  document.addEventListener('keydown', function () { mouse = false; }, true);
  document.querySelectorAll('.header__inline-menu header-menu > details').forEach(function (details) {
    var summary = details.querySelector(':scope > summary');
    var item = details.closest('li');
    if (!summary || !item) return;
    item.addEventListener('mouseenter', function () {
      if (!mq.matches) return;
      details.setAttribute('open', '');
      summary.setAttribute('aria-expanded', 'true');
    });
    item.addEventListener('mouseleave', function () {
      if (!mq.matches) return;
      details.removeAttribute('open');
      summary.setAttribute('aria-expanded', 'false');
    });
    if (summary.dataset.ntdUrl) {
      summary.addEventListener('click', function (e) {
        if (mq.matches && mouse) {
          e.preventDefault();
          window.location.href = summary.dataset.ntdUrl;
        }
      });
    }
  });
})();
